import { TEAM_ROLES } from "./roles";

/** Label amigável para o roleId (seeds do backend); fallback vazio para ids desconhecidos. */
export function roleLabel(roleId: string | null): string {
  return TEAM_ROLES.find(r => r.id === roleId)?.label ?? "";
}